<template>
  <b-overlay
  :show="loading"
  rounded="lg">
    <b-card title="Detail Delivery">
      <b-col cols="4">
        <b-button variant="primary" :to="{ name: 'completed-delivery' }" size="sm">
          <feather-icon size="1x" icon="ArrowLeftIcon" /> Back to Completed Delivery 
        </b-button>
      </b-col>
      <br />
      <b-col cols="12">
        <b-row>
          <b-col cols="12" style="margin-top:10px">
            <div class="mb-2">
              <b-row>
                <b-col cols="4"><strong>SO Number</strong></b-col>
                <b-col>: {{ formatJoin(delivery.listOrderNumber)  }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><strong>Status</strong></b-col>
                <b-col>: {{ delivery.status }}</b-col>
              </b-row>
              <b-row>
                <b-col cols="4"><strong>Created At</strong></b-col>
                <b-col>: {{ new Date(delivery.createdAt).toLocaleString() }}</b-col>
              </b-row>
            </div>
            <br>
            <b-table
              :items="deliveryItem"
              :fields="fieldPicklist"
              responsive="xl"
              hover
              head-variant="dark"
              outlined
              small
              class="table-responsive"
              sticky-header
            >
            </b-table>
          </b-col>
        </b-row>
      </b-col>
      <br />
    </b-card>
  </b-overlay>
</template>
  
<script>
  export default {
    props: ["id"],
    data() {
      return {
        fieldPicklist: [
          { key: "pickList.picklistNo", label: "Pick List Number" },
          { key: "pickList.picklistLine", label: "Line Item" },
          { key: "pickList.lineDescription", label: "Line Description" },
          { key: "pickList.fromBatch", label: "Drum Number" },
          { key: "pickList.pickListType", label: "Pick List Type" },
          { key: "pickList.quantity", label: "Quantity" },
          { key: "pickList.unit", label: "Unit" },
          { key: "pickList.binLocation", label: "Bin Location" },
          { key: "pickList.props.statusNo", label: "Status" },
          { key: "pickList.cableLengthInfo", label: "Cable Length" },
          { key: "pickList.cableWeight", label: "Cable Weight" },
          { key: "pickList.deliveryAddressOne", label: "Address 1" },
          { key: "pickList.deliveryAddressTwo", label: "Address 2" }
        ],
        delivery: {
          listOrderNumber: [],
          status: '',
          deliveryNumber: '',
          createdAt: new Date()
        },
        deliveryItem: [],
        loading: false,
        header: [
          {
            orderNumber: '',
            createdAt: '',
            deliveryAddressOne: '',
            deliveryAddressTwo: ''
          }
        ],
        disableButtonSelectPicklist: false
      };
    },

    methods: {
      formatJoin(data) {
        if (!Array.isArray(data) || data.length === 0) {
          return ''
        }
        // Remove empty strings and undefined, then deduplicate
        const filtered = Array.from(new Set(data.filter(x => x !== '' && x !== undefined && x !== ' ')))
        return filtered.join(', ')
      },
      async startDelivery() {
        this.loading = true;
        await this.$store.dispatch("delivery/processDelivery", {
          id: this.id,
          action: "start"
        })
        .then((res) => {
          this.fetchData();
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      async endDelivery() {
        this.loading = true;
        await this.$store.dispatch("delivery/processDelivery", {
          id: this.id,
          action: "end"
        })
        .then((res) => {
          this.fetchData();
          this.$router.push({ name: 'completed-delivery' });
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
      },
      async fetchData(){
        this.loading = true;
        await this.$store.dispatch("delivery/getDeliveryById", this.id)
        .then((res) => {
          
          this.delivery.listOrderNumber = res.listOrderNumber;
          this.delivery.status = res.status;
          this.delivery.deliveryNumber = res.deliveryNumber;
          this.delivery.createdAt = res.createdAt;
          if (res.item) {
            this.deliveryItem = res.item;
          }
        }).catch((err) => {
          console.error(err);
        }).finally(() => {
          this.loading = false;
        })
      }
    },
    created() {
      document.title = "Delivery Picking Process | Tai Sin";
    },
    computed: {
    },
    watch: {
    },
    mounted() {
      this.fetchData();
    },
  };
</script>

<style scoped>
.scrollable-table {
  overflow-x: auto;
  width: 100%;
}
</style>